export type WidgetHighlight = "publication";

export interface WidgetNavigationIntent {
  intent?: "checkout-button";
  highlight?: WidgetHighlight;
  onConsumeIntent?: () => void;
}

export function widgetSearch(
  search: Record<string, unknown>,
): Pick<WidgetNavigationIntent, "intent" | "highlight"> {
  return {
    ...(search.intent === "checkout-button" ? { intent: "checkout-button" as const } : {}),
    ...(search.highlight === "publication" ? { highlight: search.highlight } : {}),
  };
}
